import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Code from '../views/Code.vue'
import Login from '../views/Login.vue'

import NewClaim from '../views/NewClaim.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/newclaim',
    name: 'NewClaim',
    component: NewClaim,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/code',
    name: 'Code',
    component: Code,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/newclaim')
  }
  next();
}) 

export default router